import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ToastNotification from '../ToastNotification/ToastNotification';
import RegisterPassword2 from '../RegisterPassword2/RegisterPassword2';

const RegisterPassword = () => {
  const [licenceCode, setLicenceCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [isValidated, setIsValidated] = useState(false); // Novo estado para controlar a exibição

  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const navigate = useNavigate();

  const showMessage = (msg, type) => {
    setToast({ show: true, message: msg, type: type });
    setTimeout(() => setToast(prev => ({ ...prev, show: false })), 5000);
  };

  const handleVerifyLicence = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Ambientes - Development: localhost:8443 - Homologation: phantomtech.com.br 
      const response = await axios.post('https://phantomtech.com.br/AutomaTech/api/credentials/checkLicenceCode', {
        licenceCode: licenceCode
      });

      if (response.status === 200) {
        // Com Axios, os dados já vêm em response.data (não precisa de .json())
        const data = response.data;

        // 1. Salva o token
        localStorage.setItem('token', data.token);

        showMessage("Licença validada com sucesso! Carregando próxima etapa...", "success");

        // 2. Aguarda 2 segundos e troca a visualização
        setTimeout(() => {
          setIsValidated(true);
        }, 2000);
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message || 'Erro ao processar solicitação.';
      showMessage(errorMsg, 'error');
    } finally {
      setLoading(false);
    }
  };

  // LÓGICA DE RENDERIZAÇÃO CONDICIONAL
  if (isValidated) {
    return <RegisterPassword2 />;
  }

  return (
    <div className="container vh-100 d-flex justify-content-center align-items-center">
      {/* Componente de Toast */}
      <ToastNotification
        show={toast.show}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ ...toast, show: false })}
      />

      <div className="col-12 col-md-8 col-lg-5">
        <div className="card shadow-sm border-primary">
          <div className="card-body p-4">

            {/* Títulos Alinhados com o Passo 2 */}
            <h3 className="card-title text-center mb-1">Cadastramento de Senha - Passo 1</h3>
            <p className="text-center text-muted mb-4">Verificação de licença de uso</p>

            <form onSubmit={handleVerifyLicence}>
              <div className="mb-4">
                <label className="form-label fw-bold small text-secondary">Código da Licença de Uso</label>
                <input
                  type="text"
                  className="form-control form-control-lg text-uppercase"
                  placeholder="Insira o código recebido"
                  value={licenceCode}
                  onChange={(e) => setLicenceCode(e.target.value)}
                  required
                />
              </div>

              <div className="d-grid gap-2">
                <button
                  type="submit"
                  className="btn btn-primary btn-lg fw-bold shadow-sm"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Verificando...
                    </>
                  ) : 'ENVIAR'}
                </button>

                <button
                  type="button"
                  className="btn btn-link text-decoration-none mt-2"
                  onClick={() => navigate('/login')}
                >
                  Ir para o Login
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Rodapé informativo para manter o equilíbrio visual */}
        <div className="text-center mt-3">
          <small className="text-muted">
            <i className="bi bi-shield-lock-fill me-1"></i>
            Ambiente Seguro PhantomTech
          </small>
        </div>
      </div>
    </div>
  );

};

export default RegisterPassword;